module.exports = __webpack_public_path__ + "static/img_0211_dpp_optimized-1f3f459f0ad13a689eb07dd1999c02f3.jpg";